module.exports = __webpack_public_path__ + "img/parallax_pic.122e0f15.jpg";